<template>
    <ContentBase>
        <el-result icon="error" title="充值失败，请重试">
        </el-result>
    </ContentBase>
</template>

<script>
import ContentBase from '@/components/base/ContentBase.vue';
export default {
    components: {
        ContentBase,
    }
}
</script>

<style scoped></style>